import Carousel, { CarouselProps } from './Carousel';

export type { CarouselProps };
export default Carousel;
